import { ReactElement } from 'react'

import { SidebarMobileListItems } from './SidebarMobileListItems'

export const SidebarMobile = (): ReactElement => {
  return (
    <aside className="dark:bg-accent-4 fixed bottom-10 left-1/2 z-10 flex -translate-x-1/2 rounded-full bg-white shadow-2xl lg:hidden">
      <SidebarMobileListItems />
    </aside>
  )
}
